// import Button from '../../atoms/button/button.atom';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import Options from '../../components/options/options.component';

import './noneavailable.styles.scss';

const NoneAvailable = () => {
	

	return(
		<div className='none-box'>
            <h1>INVALID LINK!!</h1>
            <h1>NO WORRIES, CHECK OUT OUR SERVICES BELOW:</h1>
            <Options />
            <Link to="/" style={{ 
                color: 'inherit',
                textDecoration: 'inherit',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
                
            }}>
                <Button className='button'>GO BACK TO HOME</Button>
            </Link>
            
        </div>
	);
}

export default NoneAvailable;